module.exports = __webpack_public_path__ + "static/media/harvestInfoCheck.c6585dbf.svg";